/**
 * WalletMenu - Wallet dropdown menu
 */
import React from 'react';
import { Wallet, LogOut } from 'lucide-react';

const WalletMenu = ({ onSwitchWallet, onDisconnect }) => (
  <div style={{
    position: 'absolute',
    top: 'calc(100% + 8px)',
    right: 0,
    minWidth: '160px',
    background: '#1a1a1a',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '6px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
    zIndex: 1000,
    overflow: 'hidden',
  }}>
    <button
      onClick={onSwitchWallet}
      style={{
        width: '100%',
        padding: '10px 12px',
        background: 'transparent',
        border: 'none',
        borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
        color: 'var(--text-primary)',
        fontSize: '12px',
        fontWeight: 500,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        textAlign: 'left',
        transition: 'background 0.15s ease',
      }}
      onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)'}
      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
    >
      <Wallet size={14} style={{ color: '#9945FF' }} />
      Switch Wallet
    </button>
    <button
      onClick={onDisconnect}
      style={{
        width: '100%',
        padding: '10px 12px',
        background: 'transparent',
        border: 'none',
        color: '#ef4444',
        fontSize: '12px',
        fontWeight: 500,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        textAlign: 'left',
        transition: 'background 0.15s ease',
      }}
      onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(239, 68, 68, 0.1)'}
      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
    >
      <LogOut size={14} />
      Disconnect
    </button>
  </div>
);

export default WalletMenu;
